module.exports = "https://zhaopin-chat.epta.org.cn/img/at.8f7e42ae.svg";